import React from "react";

import ContainerNavs from "@/react-components/ContainerNavs";
import TrendCommentary from "@/react-components/Library/TrendCommentary";
import TaxBusinessSuccession from "@/react-components/Library/TaxBusinessSuccession";
import IPO from "@/react-components/Library/IPO";
import NriReport from "@/react-components/Library/NriReport";
import BusinessReport from "@/react-components/Library/BusinessReport";
/*import MA from "@/react-components/Library/M&A";*/
import FinancialAnalysisHint from "@/react-components/Library/FinancialAnalysisHint";
/*import Example from "@/react-components/Library/Example";*/
import url from "@/utils/url";
import config from "@/utils/config";

class LibraryInfoSection extends React.Component {
  constructor(props) {
    super(props);

    this.navList = config.libraryNavList();

    this.state = {
      activeIndex: undefined,
    };
  }

  componentDidMount() {
    const activeIndex = this.navList
      .map((item) => item.path)
      .indexOf("/" + this.props?.router?.match?.params?.sitecoreRoute);
    this.setState({
      activeIndex: activeIndex,
    });
  }

  render() {
    const { activeIndex } = this.state;
    return (
      <section className="library-main-container">
        {/* ヘッダ */}
        <ContainerNavs
          navs={this.navList}
          icMenus={{
            url: url.librarySearch,
          }}
          activeIndex={activeIndex}
          isLink={true}
        />
        {/* {activeIndex === 0 && <Example />} */}
        {activeIndex === 0 && <TrendCommentary />}
        {activeIndex === 1 && <BusinessReport />}
        {activeIndex === 2 && <NriReport />}
        {activeIndex === 3 && <TaxBusinessSuccession />}
        {activeIndex === 4 && <IPO />}
        {/* {activeIndex === 4 && <MA />} */}
        {activeIndex === 5 && <FinancialAnalysisHint />}
      </section>
    );
  }
}

export default LibraryInfoSection;
